// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LIST_OF_FORUMS = "Zoznam f\u00f3r";
export const NEWEST_DISCUSSIONS = "Najnov\u0161ie diskusie";
export const SHORTENED_SEARCH_IN_FORUM = "H\u013eadaj vo f\u00f3rach...";
export const WHERE_ARE_DISCUSSIONS = "Kde sa pr\u00e1ve diskutuje";
